<template>
  <v-main>
    <div class="world-bg d-flex align-center justify-space-between flex-column">
      <v-container fluid class="pt-14">
        <v-row>
          <v-col cols="12" class="text-center">
            <LogoTrinity routeName="Login" :width="100" class="mb-5" />
          </v-col>
        </v-row>
      </v-container>

      <!-- Shows when code was not validated yet -->
      <v-form class="auth-form" @submit.prevent.stop="codeValidation" v-if="!validatedCode">
        <v-container fluid>
          <v-row>
            <v-col cols="12" class="mb-10">
              <p class="font-weight-bold">Código de verificação</p>
              <label for="confCode" class="conf-code-container d-flex">
                <!-- eslint-disable vuejs-accessibility/no-autofocus -->
                <input
                  type="number"
                  v-model="confCode"
                  name="confCode"
                  id="confCode"
                  maxlength="6"
                  :autofocus="true"
                  @focus="digitoEmFoco = true"
                  @blur="digitoEmFoco = false"
                />
                <span class="separator elevation-4">
                  <div class="dot" v-if="confCode.length > 0">
                    {{ confCode[0] }}
                  </div>
                  <div class="dot blink" v-if="digitoEmFoco && confCode.length === 0">
                    |
                  </div>
                </span>
                <span class="separator elevation-4">
                  <div class="dot" v-if="confCode.length > 1">
                    {{ confCode[1] }}
                  </div>
                  <div class="dot blink" v-if="digitoEmFoco && confCode.length === 1">
                    |
                  </div>
                </span>
                <span class="separator elevation-4">
                  <div class="dot" v-if="confCode.length > 2">
                    {{ confCode[2] }}
                  </div>
                  <div class="dot blink" v-if="digitoEmFoco && confCode.length === 2">
                    |
                  </div>
                </span>
                <span class="separator elevation-4">
                  <div class="dot" v-if="confCode.length > 3">
                    {{ confCode[3] }}
                  </div>
                  <div class="dot blink" v-if="digitoEmFoco && confCode.length === 3">
                    |
                  </div>
                </span>
                <span class="separator elevation-4">
                  <div class="dot" v-if="confCode.length > 4">
                    {{ confCode[4] }}
                  </div>
                  <div class="dot blink" v-if="digitoEmFoco && confCode.length === 4">
                    |
                  </div>
                </span>
                <span class="separator elevation-4">
                  <div class="dot" v-if="confCode.length > 5">
                    {{ confCode[5] }}
                  </div>
                  <div class="dot blink" v-if="digitoEmFoco && confCode.length === 5">
                    |
                  </div>
                </span>
              </label>
              <p class="red--text" v-if="getError('confCode')">
                {{ getError('confCode') }}
              </p>
            </v-col>

            <v-col cols="12" class="text-center">
              <v-btn
                rounded
                color="primary"
                dark
                type="submit"
                block
                large
                class="mb-4"
              >
                Validar
              </v-btn>
            </v-col>
            <v-col cols="12" class="text-center">
              <br />
              <v-hover v-slot="{ hover }">
                <router-link
                  :to="{ name: 'Login' }"
                  :class="[
                    'text-center mb-10 font-14 bold-text',
                    hover ? 'primary--text' : getTextColor(),
                  ]"
                >
                  Voltar para Login
                </router-link>
              </v-hover>
            </v-col>
          </v-row>
        </v-container>
      </v-form>

      <!-- Shows when code was validated -->
      <v-form class="auth-form" @submit.prevent="alterarSenha" v-else>
        <v-container fluid>
          <v-row>
            <v-col cols="12">
              <p class="font-weight-bold">Redefina sua senha</p>
              <ul class="text--secondary">
                <li>Mínimo de 8 caracteres</li>
                <li>Letras maiusculas e minúsculas</li>
                <li>Letras e números</li>
                <li>Caractere especial</li>
              </ul>
            </v-col>

            <v-col cols="12">
              <span class="mb-5 font-weight-bold d-block">Nova senha</span>
              <v-text-field
                type="password"
                placeholder="• • • • • • • •"
                solo
                hide-details
                class="elevation-5 mb-3"
                v-model="userData.password"
              >
                <template v-slot:append>
                  <v-icon large color="red" v-if="getError('password')">
                    mdi-alert
                  </v-icon>
                </template>
              </v-text-field>
              <p class="red--text" v-if="getError('password')">
                {{ getError('password') }}
              </p>
            </v-col>

            <v-col cols="12">
              <span class="mb-5 font-weight-bold d-block">Confirmar senha</span>
              <v-text-field
                type="password"
                placeholder="• • • • • • • •"
                solo
                hide-details
                class="elevation-5 mb-3"
                v-model="userData.confPassword"
              >
                <template v-slot:append>
                  <v-icon large color="red" v-if="getError('confPassword')">
                    mdi-alert
                  </v-icon>
                </template>
              </v-text-field>
              <p class="red--text" v-if="getError('confPassword')">
                {{ getError('confPassword') }}
              </p>
            </v-col>

            <v-col cols="12" class="text-center">
              <v-btn
                rounded
                color="primary"
                dark
                type="submit"
                block
                large
                class="mb-4"
              >
                Confirmar
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-form>

      <v-container fluid class="pb-14"></v-container>
    </div>
  </v-main>
</template>

<script>
/* eslint-disable */
import { mapActions } from 'vuex';
import LogoTrinity from '@/components/LogoTrinity.vue';
import { api, toast } from '@/services';
import * as yup from 'yup';
import getErrors from '@/mixins/getErrors';

export default {
  name: 'RecoveryPasswordView',
  components: {
    LogoTrinity,
  },
  props: {
    email: {
      type: String,
      required: false,
      default: '',
    },
  },
  data() {
    return {
      confCode: '',
      validatedCode: false,
      userData: {
        password: '',
        confPassword: '',
      },
      digitoEmFoco: true,
      emailRecuperar: '',
      emailRedirect: '',
    };
  },
  mixins: [getErrors],
  watch: {
    confCode(codigo) {
      if (codigo.length > 6) {
        this.confCode = codigo.slice(0, 6);
      }
    },
  },
  created() {
    this.$vuetify.theme.dark = false;

    const { codigo, email } = this.$route.query;

    if (!this.email && !email) {
      this.$router.push({ name: 'ForgotPassword' });
    }

    if (codigo) {
      this.confCode = codigo;
    }

    if (email) {
      this.emailRedirect = email;
    }
  },
  methods: {
    ...mapActions(['toggleLoading']),
    getTextColor() { return (this.isDark) ? 'white--text' : 'black--text'; },
    async alterarSenha() {
      this.errors = [];
      this.toggleLoading(true);

      const schema = yup.object().shape({
        password: yup.string().required('Este campo é obrigatório.'),
        confPassword: yup.string().oneOf([yup.ref('password')], 'As senha não são iguais'),
      });

      try {
        await schema.validate(this.userData, {
          abortEarly: false,
        });

        await api.post('/autenticacao/nova_senha', {
          senha: this.userData.password,
          email: this.email || this.emailRedirect,
          codigo: this.confCode,
        });

        this.$toast.success('Senha alterada com sucesso');
        this.$router.push({ name: 'Login' });
      } catch (err) {
        if (err.response) {
          this.setError('password', err.response.data.error);
        } else if (err.inner) {
          this.setErrors(err.inner);
        }
      }
      this.toggleLoading(false);
    },
    async codeValidation() {
      this.toggleLoading(true);
      this.clearErrors();
      this.validatedCode = await api.post('/autenticacao/validar_codigo', {
        email: this.email || this.emailRedirect,
        codigo: this.confCode,
      })
        .then((response) => response.data)
        .catch((e) => {
          toast.error(e);
          return false;
        });

      if (!this.validatedCode) {
        this.setError('confCode', 'Código incorreto ou expirado');
      }

      this.toggleLoading(false);
    },
  },
};
</script>

<style scoped>
  #confCode::-webkit-outer-spin-button,
  #confCode::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  #confCode {
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: textfield;
  }

  .conf-code-container {
    border: 1px solid var(--input-border-color);
    height: 3.5rem;
    gap: 10px;
  }

  .conf-code-container input {
    opacity: 0;
    position: absolute;
    z-index: -1;
  }

  .conf-code-container .separator {
    flex: 0 0 calc(16.66% - 10px);
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: white;
    border-radius: 6px;
    font-size: 1.5rem;
  }

  .conf-code-container .separator:not(:last-of-type) {
    border-right: 1px solid var(--input-border-color);
  }
</style>
